<style scoped lang="less">
  .container {
    padding: 24px;
  }

  .content {
    background: #fff;
    padding: 24px;
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
  }
  .video-preview{
    position: fixed;
    z-index: 10;
    background:rgba(0,0,0,.6);
    top:0;
    left:0;
    width:100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content:center;
    .ivu-icon-close-circled{
      position: fixed;
      font-size: 40px;
      top:10px;
      color: #f1f1f1;
      right:10px;
    }
  }
</style>
<template>
  <div class="container">
    <div class="content">
      <div>
        <Button type="primary" @click="onAdd" icon="plus">新增任务</Button>
      </div>
      <br/>
      <Table :columns="columns" :data="data"></Table>
      <div class="pagination">
        <Page :current="currentPage" :total="total" @on-change="onChangePage"></Page>
      </div>
    </div>
    <div class="video-preview" v-if="isPreviewShow">
        <Icon type="close-circled" @click="isPreviewShow = false"></Icon>
        <video controls="" autoplay="" :src="previewUrl"></video>
    </div>
  </div>
</template>
<script>
  import {
    CREATE_TEMPLATE,
    GET_TASK_LIST
  } from '@/utils/api';
  import pagination from '@/mixins/pagination'

  export default {
    mixins:[pagination],
    data() {
      return {
        isPreviewShow:false,
        data: [],
        columns: [
          {
            title: "日期",
            key: "createTime"
          },
          {
            title: "名称",
            key: "name"
          },
//          {
//            title: "媒体",
//            key: "medie"
//          },
//          {
//            title: "秒数",
//            key: "address"
//          },
//          {
//            title: "尺寸",
//            key: "fileSize"
//          },
          {
            title: "格式",
            key: "format"
          },
          {
            title: "视频codec",
            key: "videoCodec"
          },
          {
            title: "视频码率",
            key: "videoBitRate"
          },
          {
            title: "音频codec",
            key: "audioCodec"
          },
          {
            title: "音频码率",
            key: "audioBitRate"
          },
          {
            title: "大小",
            key: "fileSize",
            render(h, { row }) {
              return <span>{row.fileSize / 1024 / 1024}MB</span>;
            }
          },
          {
            title: "状态",
            key: "status",
            render:(h, params)=>{
              if (params.row.status === 1) {
                return (
                  <span style="color:#5EA908;">进行中</span>
                )
              }else if(params.row.status === 2){
                return (
                  <div>
                    <a href={params.row.outputUrl} target="_blank">下载</a>&nbsp;&nbsp;
                    <a target="_blank" onClick={()=>{
                      this.onPreview(params.row.outputUrl)
                    }}>预览</a>
                  </div>
                )
              }else{
                return (
                  <span style="color: rgba(0,0,0,0.65);">失败</span>
                )
              }
            }
          }
        ]
      };
    },
    mounted() {
      this.fetch()
    },
    methods: {
      onAdd() {
        this.$router.push({
          name: 'transcodingTaskEdit'
        })
      },
      fetch() {
        this.$http.get(GET_TASK_LIST,{
          params:{
            page: this.currentPage,
            pageSize: this.pageSize,
            mode: 6,
            sortBy: "-vcs_task.id"
          }
        })
          .then((response) => {
            const {code, data, errorMessage} = response.body;
            if (code === 0) {
              this.data = data.list
              this.total = data.totalCount
            } else {
              this.$Message.error(errorMessage)
            }
          })
      },
      onPreview(url){
        this.isPreviewShow = true;
        this.previewUrl = url;
      }
    },
    components: {}
  };
</script>
